"use strict";
var statsSchema = {
    type: 'array',
    items: {
        type: 'string',
        pattern: 'speed|airSpeed|boatSpeed|distance|altitude|gradient|climbRate|glideRatio|elevation|altitudeFromStart|localTime|gmtTime|aeroVisionAltHeight'
    }
};
module.exports = statsSchema;
